import { DEFAULT_STATIC_VIEWER } from '../constants'

export const initialStaticViewerState = {
  staticViewer: { ...DEFAULT_STATIC_VIEWER },
}
